import { EmptyState } from '@app/components/base/EmptyState';
import SensorsOffIcon from '@mui/icons-material/SensorsOff';
import { Box, CircularProgress } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';

const noStationsTitleMessage = defineMessage({
  id: 'common.noStations.title',
  defaultMessage: 'No hay emisoras asignadas aún',
});

const noStationsHelpMessage = defineMessage({
  id: 'common.noStations.message',
  defaultMessage: 'Esperando...',
});

/**
 * Full-page empty state shown when the authenticated user has no stations assigned.
 * Rendered by AppBootstrap before the app shell when app init returns no stations.
 */
export function NoStationsPage() {
  return (
    <EmptyState
      icon={SensorsOffIcon}
      message={<FormattedMessage {...noStationsTitleMessage} />}
      help={<FormattedMessage {...noStationsHelpMessage} />}
      action={
        <Box sx={{ opacity: 0.5 }}>
          <CircularProgress size={24} />
        </Box>
      }
      centered
    />
  );
}
